import React, { memo, useState } from "react";
import { Button } from "react-bootstrap";

import { LoadingOverlay } from "../../components/LoadingOverlay/LoadingOverlay";
import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useApplications } from "../../hooks/reactQueryHooks/useApplications";
import { formatNumber } from "../../utils/NumbersFormatting";
import { ApplicationsPage } from "./components/ApplicationPage";
import { AddApplicationModal } from "./components/modals/addApplicationModal/AddApplicationModal";

const applicationsBreadcrumbs = [
  {
    title: "Projects",
    path: "",
    isSeparator: false,
    isActive: false,
  },
];

const ApplicationsWrapper: React.FC = memo(() => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleClick = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };

  const { currentOrganization } = useOrganizationContext();
  const organizationId: string = currentOrganization?.id || "";
  const { data, isLoading, isFetching } = useApplications(organizationId);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center ">
        <PageTitle
          breadcrumbs={applicationsBreadcrumbs}
          breadcrumbTitle=" "
          pageTitle={`Projects ${
            data?.length ? `(${formatNumber(data.length)})` : ""
          }`}
        />
        <div className="d-flex">
          <Button onClick={handleClick} className="flex-shrink-0 ms-md-auto">
            + Add project
          </Button>
        </div>
      </div>
      <ApplicationsPage
        data={data || []}
        isLoading={isLoading}
        isFetching={isFetching}
      />
      {showModal && (
        <AddApplicationModal show={true} handleClose={handleClose} />
      )}
      {(isLoading || isFetching) && <LoadingOverlay />}
    </>
  );
});

export { ApplicationsWrapper };
